import Head from "next/head";
import { fetchGetBanners } from "../../../services/api";
import AboutUs from "../../components/about-us/about-us";
import SingleBanner from "../../components/default/single-banner";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";

export default function AboutUsPage({ companyGeneralData, banner }) {
    companyGeneralData = JSON.parse(companyGeneralData);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content={`Conheça a MSX Motors, revenda de carros usados e seminovos em Jacareí com mais de 12 anos de mercado, procedência, garantia e bom atendimento.`} />
                <meta name="keywords" content={`sobre MSX Motors, revenda Jacareí, loja de carros Jacareí, carros usados Jacareí, seminovos Jacareí, revenda confiável`} />
                <meta name="author" content="https://bndv.com.br" />
                <title>{`Sobre a MSX Motors | Revenda de Carros em Jacareí há 12 anos`}</title>
            </Head>

            <div className="main-wrapper">
                <Header company={companyGeneralData.company} />
                {banner ? <SingleBanner imageUrl={banner.imageUrl} /> : null}
                <AboutUs company={companyGeneralData.company} />
                <Footer company={companyGeneralData.company} />
            </div>
        </>
    )
}

export async function getServerSideProps() {
    const banners = await fetchGetBanners({ idMenuOption: 2 });

    return {
        props: {
            banner: (banners && banners.length > 0) ? banners[0].banner : null
        }
    }
}